import { NgModule } from '@angular/core';
import { AppSharedModule } from '../shared/appshared.module';
import { CommonModule } from '@angular/common';
import { QuestionsComponent } from './questions.component';
import { QuestionsViewComponent, sanitizeHtmlPipe } from './questions-view/questions-view.component';
import { QuestionsRoutingModule } from './questions-routing.module';
import { TreeModule } from 'angular-tree-component';
import { BreadcrumbComponent, Breadcrumb, TreeBreadcrumb } from '../shared/custom/breadcrumb/breadcrumb.component';
import { BreadcrumbModule } from '../shared/custom/breadcrumb/breadcrumb.module';

@NgModule({
  imports: [
    CommonModule,
    QuestionsRoutingModule,
    AppSharedModule,
    TreeModule,
    BreadcrumbModule
  ],
  declarations: [sanitizeHtmlPipe,QuestionsComponent, QuestionsViewComponent],
  exports: [BreadcrumbModule, BreadcrumbComponent]
})
export class QuestionsModule { }



// WEBPACK FOOTER //
// ./src/app/questions/questions.module.ts